import Button from "@mui/material/Button"
import FilledInput from "@mui/material/FilledInput"
import FormControl from "@mui/material/FormControl"
import Icon from "@mui/material/Icon"
import InputLabel from "@mui/material/InputLabel"
import type { TitleFieldInputProps } from "./TitleFieldInputProps"

export function ButtonedInput({
  hasValidationError,
  innerValue,
  inputRef,
  label,
  onSubmit,
  placeholder,
  setHasValidationError,
  setInnerValue,
  submitIfValid,
}: TitleFieldInputProps) {
  return (
    <>
      <FormControl sx={{ flexGrow: 1, flexShrink: 1 }} variant="filled">
        <InputLabel
          sx={{ width: "100%" }}
          htmlFor="the-title"
          children={label}
          shrink
        />
        <FilledInput
          id="the-title"
          disabled={!onSubmit}
          placeholder={placeholder}
          error={hasValidationError}
          sx={{ width: "100%" }}
          onChange={(event: any) => {
            setInnerValue(event.target.value)
            setHasValidationError(false)
          }}
          value={innerValue}
          inputRef={inputRef as any}
        />
      </FormControl>
      <Button
        variant="contained"
        onClick={submitIfValid}
        startIcon={<Icon fontSize="inherit" children="cached" />}
      >
        Create Poll
      </Button>
    </>
  )
}
